// src/api/pay/index.js
import * as request from '@/utils/request'
import { param } from 'jquery';

let api = ''; // 可根据实际需求配置基础路径

/**
 * 创建订单
 * @param {Object} params - 订单参数
 * @param {string} params.membershipType - 会员类型（如monthly/quarterly/annual等）
 * @param {string} params.paymentType - 支付方式（如alipay_mobile/wechat_mobile等）
 * @param {boolean} [params.isRenewal=false] - 是否为续费订单
 * @param {string} [params.parentOrderId] - 父订单ID（续费时需要）
 * @returns {Promise} - 接口返回的Promise对象
 */
export const createOrder = (params) => {
  return request.post(api + '/createOrder', params);
};

// 可根据需要添加其他支付相关API，如：
// 取消订单
export const cancelOrder = (orderId) => {
  return request.post(api + '/cancelOrder', { orderId });
};

// 查询支付状态
export const queryPaymentStatus = (orderId) => {
  return request.post(api + '/queryPaymentStatus', { orderId });
};